module.exports = __webpack_public_path__ + "img/bergamo_hero_card.ceb5efbe.png";